"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTag = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var variants = {
  base: (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n  }"])), function (props) {
    return (0, _utils.getPalette)('background', 'c02')(props);
  }, function (props) {
    return (0, _utils.getPalette)('background', 'c01')(props);
  }, function (props) {
    return (0, _utils.getPalette)('text', 'c01')(props);
  }, function (props) {
    return (0, _utils.getPalette)('text', 'c01')(props);
  }),
  action: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n\n    ", "\n  "])), function (props) {
    return (0, _utils.getPalette)(props.color, 'c00')(props);
  }, function (props) {
    return (0, _utils.getPalette)('background', 'c02')(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.color, 'c03')(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.color, 'c03')(props);
  }, function (props) {
    return typeof props.onClick == 'function' && "&:hover {\n      color: ".concat((0, _utils.getPalette)(props.color, 'c04')(props), ";\n      background-color: ").concat((0, _utils.getPalette)(props.color, 'c00')(props), ";\n\n      svg {\n        path {\n          fill: ").concat((0, _utils.getPalette)(props.color, 'c04')(props), ";\n        }\n      }\n    }");
  }),
  status: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    color: ", ";\n  "])), function (props) {
    return (0, _utils.getPalette)(props.color, 'c00')(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.color, 'c03')(props);
  })
};

var StyledTag = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  border-radius: ", ";\n  justify-content: center;\n  height: 24px;\n  align-items: center;\n  padding: 0px 12px;\n  box-sizing: border-box;\n\n  .eui-tag-label {\n    vertical-align: middle;\n    ", "\n    color: inherit;\n  }\n\n  .eui-tag-divider {\n    display: inline-flex;\n    width: 1px;\n    background: ", ";\n    height: 18px;\n    margin-left: 7px;\n  }\n\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return (0, _utils.getBorderRadius)('tertiary')(props);
}, function (props) {
  return props.variant == 'status' ? (0, _utils.getTypography)('bodySemiBold')(props) : (0, _utils.getTypography)('label')(props);
}, (0, _utils.getPalette)('base', 'c01'), function (props) {
  return variants[props.variant];
}, _styledSystem.space, _styledSystem.width);

exports.StyledTag = StyledTag;